import SolutionRuleConfiguration from './SolutionRuleConfiguration';

export default SolutionRuleConfiguration;
